import axios from "./axios";
import qs from "qs";

export default {
  fetchReturns(params) {
    return axios.get("/node/fetchReturns", {
      params: params,
    });
  },
  fetchReturnPurchaseRecords(params) {
    return axios.get("/node/fetchReturnPurchaseRecords", {
      params: params,
    });
  },
  createReturnFromPurchases(data) {
    return axios.post("/node/createReturnFromPurchases", qs.stringify(data));
  },
  updateReturnStatus(data) {
    return axios.post("/node/updateReturnStatus", qs.stringify(data));
  },
  updateReturnAttachment(data) {
    return axios.post("/node/updateReturnAttachment", qs.stringify(data));
  },
};
